import {
  faCircleCheck,
  faLocationDot,
  faComments,
  faMagnifyingGlass,
  faFileContract,
  faUserCheck,
  faClipboardCheck,
  faCompassDrafting,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";

export const sectionImages = {
  solutions:
    "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fcd445619456a455f9b2b8ca3d94f6a62",
  sourcing:
    "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fc79f716d5b5b43a4ac01c589058ceb0c",
  getInTouch:
    "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fd4f5b60931bd4f69bccaee3a31f27bdf",
  clientStories:
    "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fef458d4fa5a34b298e2ab4125faa276b",
};

export const features = [
  {
    id: 1,
    icon: faCircleCheck,
    title: "Genuine Parts, Rigorously Tested",
    body: "Every part we supply is checked against the metallurgy the application demands, because a wear part that fails early costs more than it saved. We source from established manufacturers in Europe, China and India, and we only recommend a part once we know it will hold up on your machine.",
  },
  {
    id: 2,
    icon: faLocationDot,
    title: "On-Ground Support Across India",
    body: "Our service teams work from regional locations in Mumbai, Hyderabad, Telangana, Gujarat, Rajasthan and Kerala. That means someone who understands your equipment is reachable when a machine goes down, and critical parts are already on the shelf rather than weeks away.",
  },
  {
    id: 3,
    icon: faComments,
    title: "Transparent Technical Guidance",
    body: "We tell you what a part does, why we are recommending it, and what it will cost. Our team advises on pump selection and layout for your specific application, so you are not guessing at specifications or paying for capacity you will never use.",
  },
];

export const services = [
  {
    id: 1,
    icon: faMagnifyingGlass,
    title: "Strategic Sourcing",
    body: "Feasibility, technical and cost analysis. We make assessments on technology, cost and process before a single part is committed.",
  },
  {
    id: 2,
    icon: faFileContract,
    title: "Contract Management",
    body: "Long term supply contracts for hassle free quality supplies, price optimisation through tough negotiations and client oriented contract terms, with trend analyses to predict future risk.",
  },
  {
    id: 3,
    icon: faUserCheck,
    title: "Supplier Evaluation",
    body: "Our rigorous supplier evaluation and selection process guarantees that only the most reliable and high-quality vendors become part of our network, ensuring exceptional performance and consistency.",
  },
  {
    id: 4,
    icon: faClipboardCheck,
    title: "Quality Control",
    body: "Quality processes in place, ensuring optimum quality from every vendor during development and serial production.",
  },
  {
    id: 5,
    icon: faCompassDrafting,
    title: "Engineering Services",
    body: "Our dynamic and experienced team collaborates with your design engineers for comprehensive 3D modelling services and detailed 2D CAD drawings to convey the design intent to manufacturing.",
  },
  {
    id: 6,
    icon: faTruckFast,
    title: "On-Time Delivery",
    body: "Our unwavering commitment to punctuality ensures that your goods are delivered right on schedule, every time.",
  },
];

export const capabilities = [
  {
    id: 1,
    title: "Forging",
    body: [
      "Specializing in precision-forged components, we deliver unmatched durability and performance tailored to meet the most demanding industry standards.",
      "Possibility of multi-stage automated forging operations enable us to produce parts with complex cross-sections and high aspect ratios, tailored to your specific needs.",
    ],
    images: [
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F0e4a0c013d7343c79a01e8490adf9ee9",
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fce25890ff03846f7a0f3d07f60f5a91b",
      // "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Fe70a51ea859d40c0b6a4e97695360a75",
    ],
  },
  {
    id: 2,
    title: "Casting",
    body: [
      "Leveraging advanced sand, investment and Tilt Pressure Die casting techniques, we produce intricate and high-precision components tailored to your exact specifications.",
      "Utilizing computer-aided design (CAD) and casting simulations, we optimize mold designs to ensure high-quality, defect-free castings.",
    ],
    images: [
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F0a9b73d52f2c4b878464ed3767b4ee19",
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F98733ef0cfbf403998b92f3096cf5e75",
      // "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F8eab80a852364d0dbd2894a748fd725c",
    ],
  },
  {
    id: 3,
    title: "Fabrication / Machining",
    body: [
      "High strength steel fabrications, with precision. Experience with S690 and S960 grades.",
      "Various production processes can be utilized, e.g. laser cutting, punching, shearing and bending.",
    ],
    images: [
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F86a57892febb4563bf05f49472f35964",
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F93fda164ad9c45999eb693bf0b6c0d9c",
      // "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2Ffb6decc0379c4deeaf8468bbf780a6d3",
      {
        src: "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F4b2f149d2f4940e6a961b319c4a399f1",
        position: "41% center",
      },
    ],
  },
];

export const sectors = [
  {
    id: "construction",
    title: "Construction",
    image:
      "https://cdn.builder.io/api/v1/image/assets%2F252d9785e8284db89301f22ec23d60bb%2F26078fb0122b493c9b9ae6605e933844",
  },
  {
    id: "mining",
    title: "Mining",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/20190802-OSEC-LSC-0598_%2848443511726%29.jpg/960px-20190802-OSEC-LSC-0598_%2848443511726%29.jpg",
  },
  {
    id: "defence",
    title: "Defence",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/M2_Bradley_Fighting_Vehicle_Patrol_%286537077%29.jpg/960px-M2_Bradley_Fighting_Vehicle_Patrol_%286537077%29.jpg",
  },
  {
    id: "agriculture",
    title: "Agriculture",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Steve_Fox_plants_field_corn_into_a_stand_of_cereal_rye_in_Freedom%2C_Indiana_May_12%2C_2022_%2820220512-NRCS-BJOC-020%29.jpg/960px-Steve_Fox_plants_field_corn_into_a_stand_of_cereal_rye_in_Freedom%2C_Indiana_May_12%2C_2022_%2820220512-NRCS-BJOC-020%29.jpg",
  },
];

export const clientLogos = ["Client One", "Client Two", "Client Three"];

export const testimonials = [
  {
    id: 1,
    quote:
      "AVENTEK has been a dependable partner for our sourcing requirements. Their understanding of technical specifications, supplier coordination, and commitment to quality has helped us maintain smooth and reliable operations.",
    author: "Iyron D'Silva",
    role: "Stemtite, Australia",
  },
  {
    id: 3,
    quote:
      "Working with Aventek Engineering Services has been seamless due to their outstanding operational management. They handle the complexities of overseas manufacturing effortlessly, providing clear updates and meeting strict timelines. Their leadership team genuinely cares about quality control and client satisfaction, making them a trusted global partner.",
    author: "Dennis Marcotte",
    role: "CPIM - Director of Supply Chain",
    company: "MTI MOTION - USA",
  },
];
